import { useOutletContext } from 'react-router-dom';
import Login from 'src/components/user-mobile/parking/admin/Login';
import { IFestivalOutlet } from 'src/interfaces/overview.interface';

export default function ParkingLogin() {
  const { festivalId } = useOutletContext<IFestivalOutlet>();

  return <Login festivalId={festivalId} />;
}
